import { 
    useContext, 
    useEffect, 
    useState 
} from 'react'
import { Dialog } from "@mui/material";

import LaunchIcon from '@mui/icons-material/Launch';
import CircularProgress from '@mui/material/CircularProgress';

import { DrawerContext } from '../../context/drawerContext';
import { ContextApi } from '../../context/contextApi.js';

import styles from './style.module.scss';
import { MenuOrderingContainer } from '../menuOrdering/menuOrderingContainer';


export function MenuOrderingEstadosByRegional() {
    const {
        showMenuOrderingEstadosByRegional,
        handleCloseMenuOrderingEstadosByRegional,
        setShowMenuOrdering,
        setIdEstado
    } = useContext(DrawerContext)
    const { 
        getRegions, 
        allEstadosOrdering, 
        cookies 
    } = useContext(ContextApi)
    const [loading, setLoading] = useState(false);
    const [regionFilter, setRegionFilter] = useState([]);

    useEffect(() => {
        setLoading(true);
            if (cookies?.surfViewToken?.token && cookies?.surfViewToken?.userRole === 'regional') {
                getRegions() 
            }
    }, [])

    useEffect(() => {
        let ufFilter = []
        if(allEstadosOrdering && cookies?.surfViewToken?.userRole === 'regional') {
            Object.values(cookies?.surfViewToken?.estados).forEach(ufAcess => {
                allEstadosOrdering.forEach(ufRegs => {
                    if (ufRegs.estado_sigla === ufAcess) {
                        ufFilter.push(ufRegs)
                    }
                })
            })
            setRegionFilter(ufFilter);
            setLoading(false);
        }
    }, [allEstadosOrdering])

    function handleSeletArea(idArea) {
        setShowMenuOrdering(true)
        setIdEstado(idArea)
    }

    return (
        <>
        <Dialog
        onClose={handleCloseMenuOrderingEstadosByRegional} 
        open={showMenuOrderingEstadosByRegional}
        >
            <div className={styles.containerMenuOrderingAreaRegional}>
                <span className={styles.titleMenuOrderingRegional}>
                    Escolha qual estado deseja alterar a ordem!
                </span>
                <div className={styles.contentAreas}>
                    {regionFilter.map((area) => {
                        return (
                            <div 
                            className={styles.boxAreaRegional}
                            key={area.id}
                            onClick={() => handleSeletArea(area.estado_sigla)}
                            >
                                <p>{area.nome} - {area.estado_sigla}</p>
                                <LaunchIcon />
                            </div>
                        )
                    })}
                </div>
            </div>
            {loading &&
            <div className={styles.boxContentLoading}>
              <div className={styles.progressSpinner}>
                <CircularProgress 
                color='inherit'
                />
              </div>
            </div>}
        </Dialog>
        <MenuOrderingContainer 
        />
        </>
    )
}